import { Reveal } from "./Motion";
import { MessageCircleHeart, PhoneCall, Handshake } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function HowItWorks({ onTalk }) {
  const { t } = useLang();
  const STEPS = [
    {
      n: "1",
      icon: MessageCircleHeart,
      title: t("how.step_1_title"),
      text: t("how.step_1_text"),
      color: "hsl(var(--primary))",
      bg: "hsl(var(--sky))",
    },
    {
      n: "2",
      icon: PhoneCall,
      title: t("how.step_2_title"),
      text: t("how.step_2_text"),
      color: "hsl(var(--coral))",
      bg: "#FFE5DE",
    },
    {
      n: "3",
      icon: Handshake,
      title: t("how.step_3_title"),
      text: t("how.step_3_text"),
      color: "hsl(var(--plum))",
      bg: "#EFE7F3",
    },
  ];

  return (
    <section id="comment" className="py-16 md:py-24 relative overflow-hidden" data-testid="how-section">
      <div className="absolute inset-0" style={{ backgroundColor: "hsl(var(--primary))" }} aria-hidden="true" />
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-8 text-white">
        <Reveal>
          <div className="max-w-3xl">
            <div className="chip !bg-white/15 !text-white !border-white/25">{t("how.chip")}</div>
            <h2 className="mt-4 font-heading text-3xl md:text-5xl leading-[1.05]">{t("how.title")}</h2>
            <p className="mt-4 text-lg leading-relaxed text-white/85 max-w-2xl">{t("how.subtitle")}</p>
          </div>
        </Reveal>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-testid="how-steps">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div className="bg-white text-foreground rounded-3xl p-6 md:p-7 h-full flex flex-col">
                <div className="flex items-center gap-4">
                  <div
                    className="w-14 h-14 rounded-2xl grid place-items-center font-heading text-2xl"
                    style={{ backgroundColor: s.bg, color: s.color }}
                  >
                    {s.n}
                  </div>
                  <s.icon className="w-5 h-5 text-foreground/50" strokeWidth={2} />
                </div>
                <h3 className="mt-5 font-heading text-xl leading-tight">{s.title}</h3>
                <p className="mt-2 text-base text-foreground/75 leading-relaxed flex-1">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 md:mt-14 flex justify-center">
            <button
              onClick={onTalk}
              data-testid="how-talk-btn"
              className="pill-btn bg-white text-primary hover:bg-accent hover:text-foreground"
            >
              {t("how.cta")}
              <MessageCircleHeart className="w-4 h-4" strokeWidth={2.5} />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
